import { queryOptions, useQuery } from '@tanstack/react-query';

import { productsApi } from '../api/products-api';

import { skuRuleKeys } from './product-keys';

/** The rule a new product of this type gets and a sample style number, for the create form's placeholder. */
export function skuRuleResolveQueryOptions(productTypeId: string | null) {
  return queryOptions({
    queryKey: skuRuleKeys.resolve(productTypeId),
    queryFn: () => productsApi.resolveSkuRule(productTypeId),
    staleTime: 60_000,
  });
}

export function useSkuRuleResolve(productTypeId: string | null, enabled = true) {
  return useQuery({ ...skuRuleResolveQueryOptions(productTypeId), enabled });
}
